if ( typeof StickyAtc !== 'function' ) {

  class StickyAtc extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

    init() {

      const watchId = this.getAttribute('data-watch');
      this.watchEl = watchId ? document.getElementById(watchId) : null;

      if ( ! this.watchEl ) {
        this.watchEl = document.querySelector('[data-js-product-add-to-cart]');
      }

      if ( this.watchEl && 'IntersectionObserver' in window ) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            this.classList.toggle('is-visible', ! entry.isIntersecting);
          });
        }, { rootMargin: '0px 0px -80px 0px' });
        this.observer.observe(this.watchEl);
      } else {
        this.classList.add('is-visible');
      }

      this._syncPrice();

    }

    _syncPrice() {

      const source = document.querySelector('[data-js-product-price-original]');
      const target = this.querySelector('[data-js-sticky-price-amount]');

      if ( ! source || ! target ) {
        return;
      }

      this.priceObserver = new MutationObserver(() => {
        target.innerHTML = source.innerHTML;
      });

      this.priceObserver.observe(source, { childList: true, subtree: true, characterData: true });

    }

  }

  if ( typeof customElements.get('sticky-atc') == 'undefined' ) {
    customElements.define('sticky-atc', StickyAtc);
  }

}
